import { StateTaxPaymentModelDto } from '@treasury/api/bo';
import { AchTaxPayment } from './ach-tax-payment.entity';
import { defaultAchTaxPaymentModelDto } from './data/ach.data';

export class AchStateTaxPayment extends AchTaxPayment<StateTaxPaymentModelDto> {
    public createDefault(): this {
        return new AchStateTaxPayment(
            defaultAchTaxPaymentModelDto as StateTaxPaymentModelDto
        ) as this;
    }

    public get type() {
        return 'State';
    }

    public get state() {
        return this.dto.state && this.dto.state.name ? this.dto.state.name : '';
    }
}
